import { policies } from "./policies";

export default function Center({ currentPolicy }) {
  let policy = null;

  for (const category of Object.values(policies.categories)) {
    if (category.policies[currentPolicy]) {
      policy = category.policies[currentPolicy];
      break;
    }
  }

  if (!policy) {
    return (
      <main className="policy-content">
        <h2>Select a policy</h2>
      </main>
    );
  }

  return (
    <main className="policy-content">
      <h1>{policy.title}</h1>
      <p className="last-updated">
        Last Updated: {policy.lastUpdated}
      </p>

      {policy.sections.map(sec => (
        <section key={sec.id} id={sec.id}>
          <h2>{sec.title}</h2>
          {sec.content.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </section>
      ))}
    </main>
  );
}
